import Close from './Close';
import Hamburger from './Hamburger';
import LeftChevron from './LeftChevron';
import RightChevron from './RightChevron';
import DownChevron from './DownChevron';
import UpChevron from './UpChevron';
import UpArrow from './UpArrow';
import DownArrow from './DownArrow';
import UpDownArrow from './UpDownArrow';
import FilterIcon from './FilterIcon';
import AddIcon from './AddIcon';
import GridIcon from './GridIcon';
import TrashIcon from './TrashIcon';

export default {
  Close,
  Hamburger,
  LeftChevron,
  RightChevron,
  DownChevron,
  UpChevron,
  UpArrow,
  DownArrow,
  UpDownArrow,
  FilterIcon,
  AddIcon,
  GridIcon,
  TrashIcon,
};
